
const SetLanguage = (data) => {
    localStorage.setItem('lang', data);
}
export default SetLanguage